import React, { Component, ReactNode } from "react";
import { IntervalQuizSettings } from "../../../models/IntervalQuizSettings.model";
import { Interval, Intervals, IntervalNamesMap } from "../../../models/Intervals.model";
import FormErrorMessage from "../../generic/FormErrorMessage";
import FormSubmitButton from "../../generic/FormSubmitButton";
import LabelledCheckbox from "../../generic/LabelledCheckbox";

interface Props {
  onContinue: ({ settings }: { settings: IntervalQuizSettings }) => void;
}
interface State {
  goingUp: boolean;
  goingDown: boolean;
  intervalsEnabled: Partial<{
    [key in Interval]: boolean;
  }>;
  questionCount: number | undefined;
  formErrorMessage: string;
}

class IntervalQuizSettingsPicker extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      goingUp: true,
      goingDown: false,
      intervalsEnabled: {},
      questionCount: 5,
      formErrorMessage: "",
    };
  }

  renderTwelveNotes = () => {};

  renderIntervalList = () => {
    const { intervalsEnabled } = this.state;
    return Intervals.map((keyStr) => {
      const keyString = keyStr as Interval;
      return (
        <LabelledCheckbox
          key={keyStr}
          labelText={IntervalNamesMap[keyString]}
          isChecked={Boolean(intervalsEnabled[keyString])}
          checkboxUniqueId={"12notes" + keyStr}
          onChange={({ isChecked }) => {
            const newObj = JSON.parse(JSON.stringify(intervalsEnabled)) as typeof intervalsEnabled;
            newObj[keyString] = isChecked;
            this.setState({ intervalsEnabled: newObj, formErrorMessage: "" });
          }}
        />
      );
    });
  };

  handleFormSubmit = (e: any) => {
    e.preventDefault();
    const { goingUp, goingDown, intervalsEnabled, questionCount } = this.state;
    const newIntervals = Object.keys(intervalsEnabled).filter((t: string) => intervalsEnabled[t as Interval]);
    if (newIntervals.length < 1) {
      this.setState({ formErrorMessage: "You must select at least one interval." });
    } else {
      const settings: IntervalQuizSettings = {
        allowedDirections: { up: goingUp, down: goingDown },
        allowedIntervals: newIntervals as Array<Interval>,
        questionCount: questionCount || 5,
      };
      this.props.onContinue({ settings });
    }
  };

  render(): ReactNode {
    const { goingUp, goingDown, questionCount, formErrorMessage } = this.state;
    return (
      <section className="picker-section">
        <h3>Choose Quiz Settings</h3>
        <form className="picker-form" onSubmit={this.handleFormSubmit}>
          <h4>Which Intervals?</h4>
          <div>{this.renderIntervalList()}</div>
          <h4>In which directions?</h4>
          <div>
            <LabelledCheckbox
              labelText="Intervals going upwards"
              isChecked={goingUp}
              checkboxUniqueId="cb-going-up"
              onChange={({ isChecked }) => {
                this.setState({
                  goingUp: isChecked,
                  formErrorMessage: "",
                });
              }}
            ></LabelledCheckbox>
          </div>
          <div>
            <LabelledCheckbox
              labelText="Intervals going downwards"
              isChecked={goingDown}
              checkboxUniqueId="cb-going-down"
              onChange={({ isChecked }) => {
                this.setState({
                  goingDown: isChecked,
                  formErrorMessage: "",
                });
              }}
            ></LabelledCheckbox>
          </div>
          <h4>How many questions?</h4>
          <div>
            <input
              pattern="(^[0-9]*$)|(^$)"
              maxLength={3}
              value={questionCount || ""}
              onChange={(event) => {
                const newNum = parseInt(event.target.value);
                if (Number.isInteger(newNum)) {
                  this.setState({
                    questionCount: newNum,
                    formErrorMessage: "",
                  });
                } else if (event.target.value === "") {
                  this.setState({
                    questionCount: undefined,
                  });
                }
              }}
              onBlur={() => {
                if (!questionCount) {
                  this.setState({
                    questionCount: 5,
                  });
                }
              }}
            />
          </div>
          {/* <div>Select Starting Notes?</div> TODO.  keys are a pain*/}
          <FormSubmitButton text="Begin Quiz" />
          <FormErrorMessage>{formErrorMessage}</FormErrorMessage>
        </form>
      </section>
    );
  }
}

export default IntervalQuizSettingsPicker;
